function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import isData from "./isData.js";
import load from "./load.js";
/**
  Adds the provided value to the internal queue to be loaded, if necessary. This is used internally in new d3plus visualizations that fold in additional data sources, like the nodes and links of Network or the topojson of Geomap.
  @param f Optional formatter function applied to the loaded data.
  @param key The property name on the instance to store the loaded data.
*/ export default function(_, f, key) {
    var paths = _instanceof(_, Array) ? _ : [
        _
    ];
    var needToLoad = paths.find(isData);
    if (needToLoad) {
        var prev = this._queue.find(function(q) {
            return q[3] === key;
        });
        var d = [
            load.bind(this),
            paths,
            f,
            key
        ];
        if (prev) this._queue[this._queue.indexOf(prev)] = d;
        else this._queue.push(d);
    } else {
        this["_".concat(key)] = _;
    }
}

//# sourceMappingURL=addToQueue.js.map